const TrendDown = ({ className }: { className: string }) => (
  <svg
    aria-hidden='true'
    className={className}
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 24 24'
    fill='none'
    height='24'
    width='24'
  >
    <path
      d='m16 18 2.29-2.29-4.88-4.88-4 4L2 7.41 3.41 6l6 6 4-4 6.3 6.29L22 12v6h-6z'
      fill='currentColor'
    />
  </svg>
);

export default TrendDown;
